import { useParams } from "react-router-dom";
import { useStateWithSearchParams } from "../../../hooks";
import {
  useGeneratePlaybooksCSVForCampaignMutation,
  useGetAccountsForPlaybooksQuery,
} from "../../../api";
import { useMemo, useState } from "react";
import { ExportCSVWithInfinityScrollModal } from "./ExportCSVWithInfinityScrollModal";

type SearchParams = {
  search?: string;
};

const PER_PAGE = 25;
const START_PAGE = 1;

export const ExportPlaybooksFromCampaignModal = ({
  onClose,
}: {
  onClose: () => void;
}) => {
  const { campaign_id } = useParams();
  const [page, setPage] = useState<number>(START_PAGE);
  const [search, setSearch] = useState<string>("");

  const { searchDict } = useStateWithSearchParams<SearchParams>({
    search: undefined,
  });

  const [getPlaybooksCSV, { isLoading: isGenerationCSV }] =
    useGeneratePlaybooksCSVForCampaignMutation();

  const {
    data: companyList,
    isLoading,
    isFetching,
  } = useGetAccountsForPlaybooksQuery(
    {
      campaign_id: campaign_id!,
      page,
      per_page: PER_PAGE,
      search: search || searchDict.search,
      // include_all: true,
    },
    { refetchOnMountOrArgChange: true },
  );

  const submitHandler = (
    account_ids: string[],
    fileName: string,
    isSelectedAll: boolean,
  ) => {
    return getPlaybooksCSV({
      campaign_id: campaign_id!,
      account_ids,
      file_name: fileName.trim(),
      include_all: isSelectedAll,
    }).unwrap();
  };

  const items = useMemo(
    () =>
      (companyList?.items || [])?.map((company) => ({
        ...company,
        is_analyzed: true,
      })),
    [companyList],
  );

  const setSearchHandler = (value: string) => {
    setSearch(value);
    setPage(START_PAGE);
  };

  return (
    <ExportCSVWithInfinityScrollModal
      title={"Export Playbook Links to CSV"}
      description={
        "For which accounts would you like to export SDR playbook links?"
      }
      items={items}
      isLoading={isGenerationCSV || isLoading}
      onSubmit={submitHandler}
      onClose={onClose}
      submitBtnText={"Export Links"}
      page={page}
      loadMore={() => setPage((prev) => prev + 1)}
      isFetching={isFetching}
      canLoadMore={!!companyList && companyList?.total_pages > page}
      setSearchHandler={setSearchHandler}
      startPage={START_PAGE}
    />
  );
};
